import { provideNzIcons } from 'ng-zorro-antd/icon';
import { IcIcons } from 'libs/core/src/lib/configs/icons';
import { AuthService } from 'libs/core/src/lib/services/auth.service';
import { IcHttpConfigInterceptor } from 'libs/core/src/lib/interceptors/ic-http-interceptor.interceptor';
import { IProductsServiceToken } from 'libs/core/src/lib/services/products.service';
import { IUsersServiceInjectionToken } from 'libs/core/src/lib/services/users.service';
import { provideDarkMode } from 'libs/core/src/lib/services/dark-mode.service';
import { providePortalName } from 'libs/core/src/lib/services/notice.service';
import { provideImpersonationMode } from 'libs/core/src/lib/services/impersonation.service';
import { provideImpersonationReadOnlyMode } from 'libs/core/src/lib/interceptors/impersonation-read-only.interceptor';
import { provideTenantTheme } from 'libs/core/src/lib/services/tenant-config.service';
import { RouteTitleStrategy } from 'libs/core/src/lib/route-title-stratagy';
import { enablePerTabSession } from 'libs/core/src/lib/utils/session-store';
import { en_US, NZ_I18N } from 'ng-zorro-antd/i18n';
import { NzModalService } from 'ng-zorro-antd/modal';

import { PartnerProductsService } from './app/service/partner-products.service';
import { PartnerUserService } from './app/service/partner-user.service';
import { PartnerAuthService } from './app/service/partner-auth-service';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { provideRouter, Route, TitleStrategy } from '@angular/router';
import { resolveRepresentative } from './app/partner.resolver';
import { loginGuard } from './app/login.guard';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { NgHttpCachingModule } from 'ng-http-caching';
import { IcHttpCachingConfig } from 'libs/core/src/lib/configs/http-cache';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
  withXhr
} from '@angular/common/http';
import { AppComponent } from './app/app.component';
import { importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import {
  initializeSentry,
  provideSentryTracing,
} from '../../../libs/core/src/lib/sentry';
import { provideNzDateFnsAdapter } from 'ng-zorro-antd/core/time';


const routes: Route[] = [
  {
    path: '',
    loadChildren: () =>
      import('libs/shared-modules/src/lib/login/login.module').then((m) => m.LoginModule),
    title: 'Login',
    data: { portal: 'Partner portal' },
  },
  {
    path: 'dashboard',
    resolve: { resolvedData: resolveRepresentative },
    canActivate: [loginGuard],
    loadChildren: () =>
      import('./app/dashboard/dashboard.module').then((m) => m.DashboardModule),
  },
];
initializeSentry('Partner Portal');
// One person can be signed in to several partners at once (broker-managed partners share one domain).
enablePerTabSession();
bootstrapApplication(AppComponent, {
  providers: [
    providePortalName('partner-portal'),
    provideNzIcons(IcIcons),
    provideZoneChangeDetection(),
    importProvidersFrom(
      BrowserModule,
      FormsModule,
      LoadingBarHttpClientModule,
      LoadingBarRouterModule,
      NgHttpCachingModule.forRoot(IcHttpCachingConfig),
      LoadingBarModule,
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IcHttpConfigInterceptor,
      multi: true,
    },
    { provide: NZ_I18N, useValue: en_US },
    { provide: NzModalService },
    { provide: TitleStrategy, useClass: RouteTitleStrategy },
    {
      provide: IProductsServiceToken,
      useClass: PartnerProductsService,
    },
    {
      provide: IUsersServiceInjectionToken,
      useClass: PartnerUserService,
    },
    {
      provide: AuthService,
      useClass: PartnerAuthService,
    },
    { provide: NzNotificationService },
    provideImpersonationMode(),
    provideImpersonationReadOnlyMode(),
    provideTenantTheme(),
    provideDarkMode(),
    provideRouter(routes),
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
     provideSentryTracing(), provideNzDateFnsAdapter(),
  ],
}).catch((err) => console.error());
